module.exports = __webpack_public_path__ + "img/btn_income02.f50e918e.png";